export default __webpack_public_path__ + "static/media/placeholder_portfolio04-jp-web.b447cc35.png";